import React from 'react'

import Navbar from '../Components/Navbar'
import FlangesDetails from '../Components/FlangesDetails'
import Footer from '../Components/Footer'

const Flanges = () => {
  return (
    <div>
      <Navbar />
      <FlangesDetails />
      <Footer />
    </div>
  )
}

export default Flanges